var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"uk-lightbox":""}},[_c('a',{attrs:{"data-caption":_vm.caption,"href":_vm.src}},[_c('img',{attrs:{"alt":_vm.alt,"data-src":_vm.src+'?height='+_vm.height,"height":_vm.height,"width":_vm.width,"uk-img":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }